<script setup lang="ts">
import Hero from '@/domains/investor/components/Hero/Hero.vue'

const localePath = useLocalePath()
const router = useRoute()
const pathToPage = localePath(router.fullPath)
</script>

<template>
  <Hero
    :title="$t('investor.corporateGovernance.main.hero.title')"
    :lead="$t('investor.corporateGovernance.main.hero.lead')"
    image="/images/investor/corporate-governance/main/Hero/Hero.png"
    :second-category="{
      label: $t('investor.corporateGovernance.main.hero.secondCategory.label'),
      url:  $t('investor.corporateGovernance.main.hero.secondCategory.url'),
      aria:  $t('investor.corporateGovernance.main.hero.secondCategory.url')
    }"
    :main-category="{
      label: $t('investor.corporateGovernance.main.hero.mainCategory.label'),
      url:  pathToPage,
      aria: $t('investor.corporateGovernance.main.hero.mainCategory.aria')
    }"
    :first-button="{
      text: $t('investor.corporateGovernance.main.hero.firstButton.label'),
      to: $t('investor.corporateGovernance.main.hero.firstButton.url'),
    }"
    :second-button="{
      text: $t('investor.corporateGovernance.main.hero.secondButton.label'),
      to: $t('investor.corporateGovernance.main.hero.secondButton.url'),
      variant: 'secondary',
      target: '_blank'
    }"
  >
    <template #secondButton>
      <img
        src="/icons/icon-download-dark.svg"
        :aria-hidden="true"
      >
    </template>
  </Hero>
</template>
